import { createAction } from '@reduxjs/toolkit'

import { TPostInviteToDashboardGroupResponse } from 'redux/api/DashboardGroups/types'
import { TDashboard } from 'types/GlobalDashboard'
import {
  TResourceFilter,
  TDashboardGroupResponse,
  DashboardStatus
} from 'types/GlobalDashboardGroup'

// tryGetAllDashboardGroups
export const getAll = createAction('get_all_dashboard_groups')
export const getAllSuccess = createAction<TDashboardGroupResponse[]>(
  'get_all_dashboard_groups_success'
)
export const getAllFailed = createAction('get_all_dashboard_groups_failed')

// tryUpdateDashboardOrder
export const updateDashboardOrder = createAction('update_dashboard_order')
export const updateDashboardOrderSuccess = createAction<{
  id: string
  order: TDashboard[]
}>('update_dashboard_order_success')
export const updateDashboardOrderFailed = createAction(
  'update_dashboard_order_failed'
)

// tryCopyDashboardGroup
export const copy = createAction('copy_dashboard_group')
export const copySuccess = createAction<TDashboardGroupResponse>(
  'copy_dashboard_group_success'
)
export const copyFailed = createAction('copy_dashboard_group_failed')

// tryUpdateDashboardGroup
export const update = createAction('update_dashboard_group')
export const updateSuccess = createAction<TDashboardGroupResponse>(
  'update_dashboard_group_success'
)
export const updateFailed = createAction('update_dashboard_group_failed')

// dispatched from tryUpdateDashboardGroup when an update toggles the group's
// publish status (DRAFT <-> PUBLISHED), so the in-use count can track it
export const publishStatusChanged = createAction<{
  status: DashboardStatus
}>('dashboard_group_publish_status_changed')

// tryDeleteDashboardGroup
export const destroy = createAction('delete_dashboard_group')
export const destroySuccess = createAction<{
  id: string
  status: DashboardStatus
}>('delete_dashboard_group_success')
export const destroyFailed = createAction('delete_dashboard_group_failed')

// tryGetDeletedDashboardGroups
export const getDeleted = createAction('get_deleted_dashboard_groups')
export const getDeletedSuccess = createAction<TDashboardGroupResponse[]>(
  'get_deleted_dashboard_groups_success'
)
export const getDeletedFailed = createAction(
  'get_deleted_dashboard_groups_failed'
)

// tryRestoreDashboardGroup
export const restore = createAction('restore_dashboard_group')
export const restoreSuccess = createAction<TDashboardGroupResponse>(
  'restore_dashboard_group_success'
)
export const restoreFailed = createAction('restore_dashboard_group_failed')

// tryRevokeFromDashboard
export const revokeAccess = createAction('revoke_from_dashboard_group')
export const revokeAccessSuccess =
  createAction<TPostInviteToDashboardGroupResponse>(
    'revoke_from_dashboard_group_success'
  )
export const revokeAccessFailed = createAction(
  'revoke_from_dashboard_group_failed'
)

// tryInviteToDashboard
export const invite = createAction('invite_to_dashboard_group')
export const inviteSuccess = createAction<TPostInviteToDashboardGroupResponse>(
  'invite_to_dashboard_group_success'
)
export const inviteFailed = createAction('invite_to_dashboard_group_failed')

// tryPutDashboardGroupFilterOptions
export const putDashboardFilters = createAction('put_dashboard_group_filters')
export const putDashboardFiltersSuccess = createAction<{
  id: string
  data: TResourceFilter[]
}>('put_dashboard_group_filters_success')
export const putDashboardFiltersFailed = createAction(
  'put_dashboard_group_filters_failed'
)
